// This is a static marketing funnel page. All markup lives in public/index.html
// so search engine crawlers see fully-rendered SEO tags without executing JS.
function App() {
  return null;
}

export default App;
